
 

/*
module assumes
    -for tag <a> that disabled class exists and has the name 'disabled' -> bootstrap already provides this class

*/


export let NSControlsState = {};

NSControlsState.init = function()
{
    NSControlsStatePrivate.init();
    
	//this.f_________________________________________ = 	function () { return NSControlsStatePrivate.f_________________________________________.apply( NSControlsStatePrivate, arguments ); };
    /**
     * @description for HTML elems like: button, a, select, input (used also for checkboxes)
     */
	this.f_control_is_enabled = 	function () { return NSControlsStatePrivate.f_control_is_enabled.apply( NSControlsStatePrivate, arguments ); };
    /**
     * @description for HTML elems like: button, a, select, input (used also for checkboxes)
     */
	this.f_control_disable = 	function () { return NSControlsStatePrivate.f_control_disable.apply( NSControlsStatePrivate, arguments ); };
    /**
     * @description for HTML elems like: button, a, select, input (used also for checkboxes)
     */
	this.f_control_enable = 	function () { return NSControlsStatePrivate.f_control_enable.apply( NSControlsStatePrivate, arguments ); };
	
    /*
    this.f_input_is_enabled = 	    function () { return NSControlsStatePrivate.f_input_is_enabled.apply( NSControlsStatePrivate, arguments ); };
	this.f_input_disable = 	        function () { return NSControlsStatePrivate.f_input_disable.apply( NSControlsStatePrivate, arguments ); };
	this.f_input_enable = 	        function () { return NSControlsStatePrivate.f_input_enable.apply( NSControlsStatePrivate, arguments ); };
    this.f_button_is_enabled = 	    function () { return NSControlsStatePrivate.f_button_is_enabled.apply( NSControlsStatePrivate, arguments ); };
	this.f_button_disable = 	    function () { return NSControlsStatePrivate.f_button_disable.apply( NSControlsStatePrivate, arguments ); };
	this.f_button_enable = 	        function () { return NSControlsStatePrivate.f_button_enable.apply( NSControlsStatePrivate, arguments ); };
	this.f_select_is_enabled = 	    function () { return NSControlsStatePrivate.f_select_is_enabled.apply( NSControlsStatePrivate, arguments ); };
	this.f_select_disable = 	    function () { return NSControlsStatePrivate.f_select_disable.apply( NSControlsStatePrivate, arguments ); };
	this.f_select_enable = 	        function () { return NSControlsStatePrivate.f_select_enable.apply( NSControlsStatePrivate, arguments ); };
	this.f_checkbox_is_enabled = 	function () { return NSControlsStatePrivate.f_checkbox_is_enabled.apply( NSControlsStatePrivate, arguments ); };
	this.f_checkbox_disable = 	    function () { return NSControlsStatePrivate.f_checkbox_disable.apply( NSControlsStatePrivate, arguments ); };
	this.f_checkbox_enable = 	    function () { return NSControlsStatePrivate.f_checkbox_enable.apply( NSControlsStatePrivate, arguments ); };
	
    this.f_tag_a_of_type_button_is_enabled =    function () { return NSControlsStatePrivate.f_tag_a_of_type_button_is_enabled.apply( NSControlsStatePrivate, arguments ); };
	this.f_tag_a_of_type_button_disable = 	    function () { return NSControlsStatePrivate.f_tag_a_of_type_button_disable.apply( NSControlsStatePrivate, arguments ); };
	this.f_tag_a_of_type_button_enable = 	    function () { return NSControlsStatePrivate.f_tag_a_of_type_button_enable.apply( NSControlsStatePrivate, arguments ); };
    */


	//window.NSControlsState = NSControlsState;
	window.NSControlsState_ = NSControlsState;
	window.NSControlsStatePrivate_ = NSControlsStatePrivate;
	
}



let NSControlsStatePrivate =
{
    private_objs: {
        CONSTS:
        {
            s_HTML_DISABLED_ATTRIBUTE: 'disabled',
            s_DISABLED_CLASS: 'disabled'
        }
    },

    init: function()
    {
        
    },


    f_control_is_enabled: function(e_)
    {
        let s_tag_name_lc = e_.tagName.toLowerCase();

        if(s_tag_name_lc== 'input') //includes type="checkbox"
        {
            return this.f_input_or_button_or_select_is_enabled(e_);
        }
        else if(s_tag_name_lc == 'button')
        {
            return this.f_input_or_button_or_select_is_enabled(e_);
        }
        else if(s_tag_name_lc == 'select')
        {
            return this.f_input_or_button_or_select_is_enabled(e_);
        }
        else if(s_tag_name_lc == 'a')
        {
            return this.f_tag_a_of_type_button_is_enabled(e_);
        }
    },
    f_control_disable: function(e_)
    {
        let s_tag_name_lc = e_.tagName.toLowerCase();

        if(s_tag_name_lc == 'input') //includes type="checkbox"
        {
            return this.f_input_or_button_or_select_disable(e_);
        }
        else if(s_tag_name_lc == 'button')
        {
            return this.f_input_or_button_or_select_disable(e_);
        }
        else if(s_tag_name_lc == 'select')
        {
            return this.f_input_or_button_or_select_disable(e_);
        }
        else if(s_tag_name_lc == 'a')
        {
            return this.f_tag_a_of_type_button_disable(e_);
        }
    },
    f_control_enable: function(e_)
    {
        let s_tag_name_lc = e_.tagName.toLowerCase();

        if(s_tag_name_lc == 'input') //includes type="checkbox"
        {
            return this.f_input_or_button_or_select_enable(e_);
        }
        else if(s_tag_name_lc == 'button')
        {
            return this.f_input_or_button_or_select_enable(e_);
        }
        else if(s_tag_name_lc == 'select')
        {
            return this.f_input_or_button_or_select_enable(e_);
        }
        else if(s_tag_name_lc == 'a')
        {
            return this.f_tag_a_of_type_button_enable(e_);
        }
    },


    f_input_is_enabled: function(e_)
	{
		return this.f_input_or_button_or_select_is_enabled(e_);
	},
    f_input_disable: function(e_)
	{
		return this.f_input_or_button_or_select_disable(e_);
	},
    f_input_enable: function(e_)
	{
		return this.f_input_or_button_or_select_enable(e_);
	},

    f_tag_a_of_type_button_is_enabled: function(e_)
	{
		//return this.f_input_or_button_or_select_is_enabled(e_);
        
		let b_is_enabled = ( e_.classList.contains(this.private_objs.CONSTS.s_DISABLED_CLASS) )? false : true;
        return b_is_enabled;
	},
    f_tag_a_of_type_button_disable: function(e_)
	{
		this.f_input_or_button_or_select_disable(e_);
        if( this.f_tag_a_of_type_button_is_enabled(e_) )
        {
            e_.classList.add(this.private_objs.CONSTS.s_DISABLED_CLASS);
        }
	},
    f_tag_a_of_type_button_enable: function(e_)
	{
		this.f_input_or_button_or_select_enable(e_);
        e_.classList.remove(this.private_objs.CONSTS.s_DISABLED_CLASS);
	},

    f_button_is_enabled: function(e_)
	{
		return this.f_input_or_button_or_select_is_enabled(e_);
	},
    f_button_disable: function(e_)
	{
		return this.f_input_or_button_or_select_disable(e_);
	},
    f_button_enable: function(e_)
	{
		return this.f_input_or_button_or_select_enable(e_);
	},

    f_select_is_enabled: function(e_)
	{
		return this.f_input_or_button_or_select_is_enabled(e_);
	},
    f_select_disable: function(e_)
	{
		return this.f_input_or_button_or_select_disable(e_);
	},
    f_select_enable: function(e_)
	{
		return this.f_input_or_button_or_select_enable(e_);
	},

    f_checkbox_is_enabled: function(e_)
	{
		return this.f_input_or_button_or_select_is_enabled(e_);
	},
    f_checkbox_disable: function(e_)
	{
		return this.f_input_or_button_or_select_disable(e_);
	},
    f_checkbox_enable: function(e_)
	{
		return this.f_input_or_button_or_select_enable(e_);
	},

    

    f_input_or_button_or_select_is_enabled: function(e_)
	{
		let s_ = this.private_objs.CONSTS.s_HTML_DISABLED_ATTRIBUTE;
		let b_is_enabled = (e_.hasAttribute(s_) == true)? false : true;
		
		return b_is_enabled;
	},
	f_input_or_button_or_select_enable: function(e_)
	{
		let s_ = this.private_objs.CONSTS.s_HTML_DISABLED_ATTRIBUTE;
		e_.removeAttribute(s_);
		
	},
	f_input_or_button_or_select_disable: function(e_)
	{
        if(this.f_input_or_button_or_select_is_enabled(e_))
        {
            let s_ = this.private_objs.CONSTS.s_HTML_DISABLED_ATTRIBUTE;
            e_.setAttribute(s_, s_);
        }
	}

}